import React from "react";
import RenderResourcesVideos from "./RenderResoursesVideos";

const employerResourcesVideos = [
  {
    name: "Accessing the Portal",
    link: "https://www.loom.com/embed/c4abe4d373d04816a689879bec66f3f9?sid=368570e0-3c96-4877-92ab-e605ad8eafb8",
  },
  {
    name: "Managing Employees",
    link: "https://www.loom.com/embed/f3d46f3b930b4005978a2e84958be581",
  },
  {
    name: "Employee Sign Up Process",
    link: "https://www.loom.com/embed/6668a5769297477da1f1de4f6a75d059",
  },
  {
    name: "How to add employees",
    link: "https://www.loom.com/embed/f1f1e98ad7874b6b80fa28938890d29d",
  },
  {
    name: "Employer Dashboard Overview",
    link: "https://www.loom.com/embed/1961973caa5a41bf921a4d1a5dd46e05",
  },
];

const EmployerResources = () => {
  return (
    <div>
      <RenderResourcesVideos resourcesVideos={employerResourcesVideos} />
    </div>
  );
};

export default EmployerResources;
